module.exports = __webpack_public_path__ + "static/quot-logo-1-30fee200e2beb26bd721a2e7c29f6386.png";